import React from 'react';
import { Icons } from './Icon';

export interface MissingFilesState {
    subfolder?: string | null;
    photos: any[];
    documents: any[];
}

export interface ProjectMissingFilesBannerProps {
    missingFiles: MissingFilesState;
    onDismiss: () => void;
}

export const ProjectMissingFilesBanner: React.FC<ProjectMissingFilesBannerProps> = ({
    missingFiles,
    onDismiss,
}) => {
    if (!missingFiles.subfolder && (!missingFiles.photos || missingFiles.photos.length === 0) && (!missingFiles.documents || missingFiles.documents.length === 0)) {
        return null;
    }

    return (
        <div className={`border-b px-4 py-2 ${missingFiles.subfolder ? 'bg-red-50 border-red-200' : 'bg-amber-50 border-amber-200'}`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Icons.AlertTriangle size={16} className={missingFiles.subfolder ? 'text-red-600' : 'text-amber-600'} />
                    <span className={`text-sm font-medium ${missingFiles.subfolder ? 'text-red-800' : 'text-amber-800'}`}>
                        {missingFiles.subfolder
                            ? `Project subfolder not found: "${missingFiles.subfolder}"`
                            : 'Some files could not be loaded from the project folder'}
                    </span>
                    {!missingFiles.subfolder && (missingFiles.photos.length > 0 || missingFiles.documents.length > 0) && (
                        <span className="text-xs text-amber-600">
                            ({missingFiles.photos.length} photos, {missingFiles.documents.length} documents)
                        </span>
                    )}
                </div>
                <button
                    onClick={onDismiss}
                    className={`p-2 rounded-lg transition-colors ${missingFiles.subfolder ? 'text-red-600 hover:text-red-800 hover:bg-red-100' : 'text-amber-600 hover:text-amber-800 hover:bg-amber-100'}`}
                    title="Dismiss"
                >
                    <Icons.X size={18} />
                </button>
            </div>
            {missingFiles.subfolder && (
                <div className="mt-1 text-xs text-red-700">
                    The folder may have been moved, renamed, or deleted. Files could not be loaded.
                </div>
            )}
            {!missingFiles.subfolder && (missingFiles.photos.length > 0 || missingFiles.documents.length > 0) && (
                <div className="mt-1 text-xs text-amber-700">
                    {missingFiles.photos.length > 0 && (
                        <span className="mr-4">
                            Missing photos: {missingFiles.photos.slice(0, 3).join(', ')}
                            {missingFiles.photos.length > 3 && ` +${missingFiles.photos.length - 3} more`}
                        </span>
                    )}
                    {missingFiles.documents.length > 0 && (
                        <span>
                            Missing documents: {missingFiles.documents.slice(0, 3).join(', ')}
                            {missingFiles.documents.length > 3 && ` +${missingFiles.documents.length - 3} more`}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProjectMissingFilesBanner;
